export const getItemsByOrchidProType = (items, orchidProTypeId) => {
  return items?.filter((item) => item.orchid_pro_type_id === orchidProTypeId);
};

export const getItemsNotCurrOrchidProType = (items, orchidProTypeId) => {
  return items?.filter((item) => item.orchid_pro_type_id !== orchidProTypeId);
};
